module.exports = __webpack_public_path__ + "img/circle2.e9fd0485.svg";